import React from 'react';
import ModulePage from '../components/ModulePage';
import { moduleLandingData } from '../mock/moduleLandingData';

export default function SalesPage() {
  return <ModulePage data={moduleLandingData.sales} />;
}
